import { makeAutoObservable } from 'mobx'

class Widget {
  isWidget = false
  constructor() {
    makeAutoObservable(this, {}, { autoBind: true })
  }

  setIsWidget(value: boolean) {
    this.isWidget = value
  }
}

export const widgetStore = new Widget()
